import React from "react";
import { useEffect, useState } from "react";
import { useParams, NavLink, Outlet, Routes, Route } from "react-router-dom";
import { useApi } from "../../context/ApiProvider";
import 'chart.js/auto'; //Todo: Kolla mer på vad "Tree-shaking" är: https://react-chartjs-2.js.org/docs/migration-to-v4
import { Line } from "react-chartjs-2";

const OrganisationReflectionTrend = React.lazy(() => import("./Statistics/PartnerReflectionTrend"));
const OrganisationUserActivity = React.lazy(() => import("./Statistics/PartnerUserActivity"));

export default function PartnerStatistics(props) {
  return (
    <Routes>
      <Route path="/*" element={<StatisticsLayout />}>
        <Route index element={<StatisticsView view="usagestatistics" />} />
        <Route path="reflectiontrend" element={<StatisticsView view="reflectiontrend" />} />
        <Route path="useractivity" element={<StatisticsView view="useractivity" />} />
      </Route>
    </Routes>
  );
}

function StatisticsLayout() {
  return (
    <>
      <nav>
        <ul className='nav'>
          <li>
            <NavLink to="" end className={({ isActive }) =>
              isActive ? 'active' : undefined}>Usage statistics</NavLink>
          </li>
          <li>
            <NavLink to="./reflectiontrend" className={({ isActive }) =>
              isActive ? 'active' : undefined}>Reflection trend</NavLink>
          </li>
          <li>
            <NavLink to="./useractivity" className={({ isActive }) =>
              isActive ? 'active' : undefined}>User activity</NavLink>
          </li>
        </ul>
      </nav>
      <Outlet />
    </>
  );
}

function StatisticsView(props) {
  const { view } = props;

  

  const components = {
    usagestatistics: <UsageStatistics />,
    reflectiontrend: <OrganisationReflectionTrend />,
    useractivity: <OrganisationUserActivity />,
  }

  return (

    <React.Suspense fallback={<div>Loading...</div>}>
      {components[view]}
    </React.Suspense>

  );
}

function UsageStatistics() {
  const { organisationId, clientId } = useParams();
  const Api = useApi();
  const [hasPermission, setHasPermission] = useState(false);
  const [isLoadingStats, setIsLoadingStats] = useState(false);
  const [stats, setStats] = useState(false);
  const [traverse, setTraverse] = useState(false);
  const [diagramDatasets, setDiagramDatasets] = useState(false);
  const [maxValues, setMaxValues] = useState(false);

  useEffect(() => {
    loadStats();
  }, [traverse, organisationId]);

  useEffect(() => {
    // Leta reda på maxvalues från datat
    const getMaxValues = () => {
      let prev = { lcs: 1, lcsself: 1, notes: 1, activity: 1, log: 1 };
      stats && stats.map((month, index) => {
        prev = {
          lcs: prev.lcs < month.lcs ? month.lcs : prev.lcs,
          lcsself: prev.lcsself < month.lcsself ? month.lcsself : prev.lcsself,
          notes: prev.notes < month.notes ? month.notes : prev.notes,
          activity: prev.activity < month.activity ? month.activity : prev.activity,
          log: prev.log < month.log ? month.log : prev.log,
        }
        return prev;
      });
      setMaxValues(prev);
    }
    getMaxValues();
    return () => { }
  }, [stats]);

  useEffect(() => {

    // Definiera dataset för diagrammet
    const diagramDatasets = [
      { id: 1, label: 'Rolfings', data: [], backgroundColor: "#5747AB", borderColor: "#5747AB" },
      { id: 2, label: 'Self rolfings', data: [], backgroundColor: "#FF9EB5", borderColor: "#FF9EB5" },
      { id: 3, label: 'Notes', data: [], backgroundColor: "#FFE061", borderColor: "#FFE061" },
      { id: 4, label: 'Activities', data: [], backgroundColor: "#36ABF0", borderColor: "#36ABF0" },
      { id: 5, label: 'Reflection logs', data: [], backgroundColor: "#82E5D6", borderColor: "#82E5D6" }
    ]

    // Fyll i dataset med data
    stats && stats.map((month, index) => {
      diagramDatasets[0].data[index] = parseFloat(month.lcs / maxValues.lcs) * 100 || 0;
      diagramDatasets[1].data[index] = parseFloat(month.lcsself / maxValues.lcsself) * 100 || 0;
      diagramDatasets[2].data[index] = parseFloat(month.notes / maxValues.notes) * 100 || 0;
      diagramDatasets[3].data[index] = parseFloat(month.activity / maxValues.activity) * 100 || 0;
      diagramDatasets[4].data[index] = parseFloat(month.log / maxValues.log) * 100 || 0;

    });

    // Sätt state
    setDiagramDatasets(diagramDatasets);

  }, [maxValues])

  const loadStats = () => {
    setIsLoadingStats(true);
    Api.get(`/partners/${clientId}/statistics?${traverse ? '' : 'noTraverse=true'}`).then(data => {
      setHasPermission(true);
      setStats(data);
    }).catch(e => {
      if (e.status === 403)
        setHasPermission(false);
    }).finally(() => {
      setIsLoadingStats(false);
    })
  }

  if (isLoadingStats) {
    return <div>Loading...</div>
  }

    if(!hasPermission) {
        return <div className="formControlError">Permission error: You do not have permission to view this.</div>
    }


  return (
    <div className='grid-container'>

      <section>
        <h4 className='spaceBetween '>
          <span>Usage statistics</span>
          <span>

            <input type='checkbox' checked={traverse} onChange={e => setTraverse(e.target.checked)} />
            <span className="meta">Include sub-organisations</span>
          </span>
        </h4>

        {diagramDatasets && <Line datasetIdKey='id' options={{ cubicInterpolationMode: "monotone" }}
          data={{
            labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
            datasets: diagramDatasets,
          }}
          style={{ marginBottom: "3rem" }} />
        }

        <table style={{ marginBottom: "3rem" }}>
          <thead>
            <tr>
              <th>Month</th >
              <th>Rolfings</th >
              <th>Self rolfings</th >
              <th>Notes</th >
              <th>Activities</th>
              <th>Reflection logs</th>
            </tr>
          </thead>
          <tbody>
            {stats && stats.map((month, k) => {
              return <tr key={k}>
                <td>{month.name}</td>
                <td>{month.lcs || '-'}</td>
                <td>{month.lcsself || '-'}</td>
                <td>{month.notes || '-'}</td>
                <td>{month.activity || '-'}</td>
                <td>{month.log || '-'}</td>
              </tr>
            })
            }
          </tbody>
        </table>
      </section>
    </div>
  )
}